import { CircleText, QuestionDisplayMode } from '@doltech/ui/lib/figma/CircleText/CircleText';
import { QuestionV2 } from '@doltech/ui/lib/figma/Question/QuestionV2';
import { QUESTION_OPTION_PADDING } from '@doltech/utils/lib/constants';
import { numberToABC } from '@doltech/utils/lib/text';
import cl from 'classnames';
import { range } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { DoTestMultipleAnswerQuestionInstance } from '../student-do-test/model/Question/do-test-multiple-answer-question.store';
import { useTestSubmissionStore } from '../student-do-test/model/test-submissions.hook';
import { SingleAnswerMain } from './SingleAnswer';

interface MultipleAnswerProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestMultipleAnswerQuestionInstance;
}

const CircleTextWrapper = styled.div`
  margin: 0 ${QUESTION_OPTION_PADDING}px;
`;

const Main = styled(SingleAnswerMain)``;

export const MultipleAnswer = observer((props: MultipleAnswerProps) => {
  const { data, ...rest } = props;
  const {
    question,
    options,
    formattedQuestionNo,
    notes,
    onAnswerQuestion,
    setNotes,
    userAnswers = [],
    maxSelectedOptions,
    setQuestionProgress,
    no,
  } = data;
  const store = useTestSubmissionStore();
  return (
    <Main className="dol-question" {...rest}>
      {range(no + 1, no + maxSelectedOptions).map((questionNo) => {
        return <div key={questionNo} id={`question-no-${questionNo}`} />;
      })}
      <QuestionV2
        no={formattedQuestionNo}
        content={question}
        onChangeQuestion={setQuestionProgress}
      />

      <div className="question-option-list">
        {options.map((option, index) => {
          const { key, value } = option;
          const selected = userAnswers && userAnswers.includes(key);
          const note = notes?.find((o) => o.key === key)?.value;
          return (
            <CircleTextWrapper key={key}>
              <CircleText
                note={note}
                onSetNote={(updatedValue) => setNotes({ key, value: updatedValue })}
                onClick={() => {
                  if (store.preventUserAction()) return;
                  onAnswerQuestion([option]);
                }}
                className={cl('question-option-wrapper', { selected })}
                circleText={numberToABC(index + 1)}
                displayMode={QuestionDisplayMode.QUESTION_OPTION}
                selected={selected}
                text={value}
              />
            </CircleTextWrapper>
          );
        })}
      </div>
    </Main>
  );
});
